<script lang="ts">
	import type { QuotesBlock } from '$models/Block/QuotesBlock';

	interface Props {
		block: QuotesBlock;
	}

	const { block }: Props = $props();
</script>

<div
	class={['quotes', block.variant && `variant-${block.variant}`]}
	style:background-color={block.backgroundColor}
>
	<div class="quotes-inner">
		{#if block.image}
			<figure class="quotes-image">
				<img
					src={block.image.url}
					alt={block.image.alt}
					width={block.image.width}
					height={block.image.height}
					loading="lazy"
					decoding="async"
				/>
			</figure>
		{/if}
		<div class="quotes-content">
			{#if block.title}
				<h2 class="quotes-title h4">{@html block.title}</h2>
			{/if}
			{#if block.subtitle}
				<div class="quotes-subtitle">{@html block.subtitle}</div>
			{/if}
		</div>
	</div>
</div>

<style lang="postcss">
	.quotes {
		max-width: 1120px;
		margin-inline: auto;
		background-color: var(--color-primary-light);
		border-radius: var(--radius-5);
		overflow: hidden;

		&-inner {
			display: flex;
			flex-direction: column-reverse;
			gap: 24px;
			padding: 40px 24px 0;
		}

		&-image {
			flex: 0 0 auto;
			width: 100%;
			overflow: hidden;
			max-width: 420px;
			margin-inline: auto;

			img {
				display: block;
				width: 100%;
				height: 100%;
				aspect-ratio: 1;
				object-fit: cover;
			}
		}

		&-content {
			display: flex;
			flex-direction: column;
			gap: 40px;
			flex: 1 1 auto;
		}

		&-title {
			font-size: 20px;
			line-height: 1;
		}

		&.variant-dark {
			color: var(--color-white);
			background-color: var(--variant-dark-color);
		}

		&.variant-tint-1 {
			background-color: var(--variant-tint-1-color);
		}

		&.variant-tint-2 {
			background-color: var(--variant-tint-2-color);
		}

		&.variant-tint-3 {
			background-color: var(--variant-tint-3-color);
		}

		&.variant-tint-4 {
			background-color: var(--variant-tint-4-color);
		}

		@media (--sm) {
			&-inner {
				flex-direction: row;
				gap: 16px;
				padding: 24px 40px 0 24px;
			}

			&-image {
				width: 45%;
				align-self: flex-end;
			}

			&-content {
				align-self: center;
				padding-bottom: 24px;
			}
		}

		@media (--lg) {
			&-inner {
				padding: 40px 80px 0 40px;
			}

			&-title {
				font-size: 28px;
			}

			&-subtitle {
				font-size: 18px;
			}

			&-content {
				padding-bottom: 24px;
			}
		}
	}
</style>
